/**
 * Centralized regex patterns for validators
 */

export const EMAIL_ADDRESS_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const ID_NUMBER_PATTERN = /^\d+$/;
export const NAME_PATTERN = /^(?=.*[A-Za-z\u00C0-\u017F])[A-Za-z\u00C0-\u017F\s'-]+$/;
export const NUMBER_DECIMAL_PATTERN = /^\d+(\.\d+)?$/;
export const HH_SIZE_PATTERN = /^\d{1,2}$/;
export const PHONE_NUMBER_PATTERN = /^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
export const SOCIAL_SECURITY_PATTERN = /^(?!000|666|9\d{2})\d{3}-?(?!00)\d{2}-?(?!0000)\d{4}$/;
export const SPECIAL_CHAR_PATTERN = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
export const TEN_DIGIT_NUMBER_PATTERN = /^\d{10}$/;
export const URL_PATTERN = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/;
export const ZIP_CODE_PATTERN = /^\d{5}$/;